/**
 * Handle Billing interface
 */
const $inject = ['$scope', '$interval', 'PharmacistService'];

class BillingController {


    /**
     * @constructor
     * @param $scope
     * @param $interval
     * @param PharmacistService
     */
    constructor($scope, $interval, PharmacistService) {

        // Settings
        this.debug = true;
        this.interval = $interval;
        this.listeningInterval = 15 * 1000; // Milliseconds

        // Default values
        this.pharmacist = {};
        this.buttonText = '';
        this.accept_price = '';
        this.submit_price = '';
        this.calendarStatus = { opened: false };
        this.listeningPromise = null;

        // Components
        this.PharmacistService = PharmacistService;

        // Initialisation
        this.get();

        // Destroy any intervals on leaving the page
        var self = this;
        $scope.$on('$destroy', function () {
            if(self.listeningPromise) {
                self.interval.cancel(self.listeningPromise);
            }
        });

    }

    /**
     * Release Date
     * @todo this should probably be a directive
     */
    openCalendar($event) {
        this.calendarStatus = { opened: true };
    }

    /**
     * Format the date appropriately
     * @param date
     * @returns {string}
     */
    formatDate(date) {
        var day = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString();
        var numMonth = (date.getMonth()+1);
        var month = numMonth < 10 ? '0'+ numMonth.toString() : numMonth.toString();
        var year = date.getFullYear().toString();
        return year + '-' + month + '-' + day;
    }

    /**
     * Update the model for the expiration date
     * @param date
     */
    selectDate(date) {
        this.pharmacist.expirationDate = this.formatDate(date);
    }

    /**
     * Get pharmacist details
     * @param   {Boolean}   forceRefresh
     */
    get(forceRefresh) {

        var self = this;

        var handleSuccess = function (response) {
            if (!response.data.error) {
                self.loading = false;
                self.pharmacist = response.data.data.account;
                self.buttonText = self.pharmacist.paymentToken ? 'Update payment details' : 'Add payment details';
                self.prices = {};
                for (let price of self.pharmacist.pharmacist.prices) {
                    self.prices[price.product.code] = '$' + price.price;
                }
                if(self.listeningPromise && self.pharmacist.paymentToken) {
                    self.interval.cancel(self.listeningPromise);
                    self.listeningPromise = null;
                }
            }
            else {
                handleError(response);
            }
        };

        var handleError = function (response) {
            //TODO define behaviour
            self.loading = false;
        };

        this.loading = true;
        this.PharmacistService.get(handleSuccess, handleError, forceRefresh);
    }

    /**
     * Check whether the user has added their payment details
     * If the pharmacist doesn't have payment details, when they click the "add payments details",
     * the interface will check regularly whether the payment details so that the user doesn't have to refresh the page
     */
    listen() {
        // It's only relevant if you don't already have payment details
        if(!this.pharmacist.paymentToken) {
            var self = this;
            this.listeningPromise = this.interval(function() {
                self.get(true);
            }, this.listeningInterval);
        }
    }

}

BillingController.$inject = $inject;

export default BillingController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/pharmacist/controllers/billing.controller.js
 **/